import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var WeekTimetable;
(function (WeekTimetable) {
    WeekTimetable.get = createAccessors(arrayGetSet('week_timetables'), {
        temp7: [],
    });
})(WeekTimetable || (WeekTimetable = {}));
